// Camera barcode scanning helpers. The heavy pieces (overlay + ZXing) are lazy chunks.
const MODE_KEY = "samrtin_camera_mode";
export const FORMATS = ["ean_13", "ean_8", "upc_a", "upc_e", "code_128", "code_39", "qr_code"];

let camCache;
export async function hasCamera() {
  if (!navigator.mediaDevices?.getUserMedia || !navigator.mediaDevices.enumerateDevices) return false;
  if (camCache !== undefined) return camCache;
  try {
    camCache = (await navigator.mediaDevices.enumerateDevices()).some((d) => d.kind === "videoinput");
  } catch {
    camCache = false;
  }
  return camCache;
}

export const getMode = () => (localStorage.getItem(MODE_KEY) === "single" ? "single" : "continuous");
export const setMode = (m) => localStorage.setItem(MODE_KEY, m);

// Warm the lazy chunks once the POS is idle and hand their URLs to the service worker so camera scanning works offline.
export function prefetchScanner() {
  const go = () => {
    Promise.all([
      import(/* webpackChunkName: "camera-scanner" */ "@/components/scan/CameraOverlay"),
      import(/* webpackChunkName: "zxing" */ "@zxing/library"),
    ]).then(() => {
      const urls = performance.getEntriesByType("resource").map((e) => e.name).filter((u) => /(zxing|camera-scanner)[^/]*\.js(\?|$)/.test(u));
      if (urls.length && navigator.serviceWorker) navigator.serviceWorker.ready.then((r) => r.active?.postMessage({ type: "cache-urls", urls })).catch(() => {});
    }).catch(() => {});
  };
  (window.requestIdleCallback || ((f) => setTimeout(f, 1500)))(go);
}

// UPC-A ↔ EAN-13 (leading 0) so either symbology finds the product.
export function codeVariants(code) {
  const c = String(code).trim();
  const out = [c];
  if (/^\d{12}$/.test(c)) out.push(`0${c}`);
  if (/^0\d{12}$/.test(c)) out.push(c.slice(1));
  return out;
}

let audio;
export function primeAudio() {
  try {
    audio ||= new (window.AudioContext || window.webkitAudioContext)();
    if (audio.state === "suspended") audio.resume();
  } catch { /* no WebAudio */ }
}

export function beep(ok = true) {
  try {
    primeAudio();
    const o = audio.createOscillator();
    const g = audio.createGain();
    o.frequency.value = ok ? 1250 : 380;
    g.gain.setValueAtTime(0.18, audio.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, audio.currentTime + (ok ? 0.09 : 0.22));
    o.connect(g).connect(audio.destination);
    o.start();
    o.stop(audio.currentTime + (ok ? 0.1 : 0.24));
  } catch { /* silent */ }
  try { navigator.vibrate?.(ok ? 60 : [40, 60, 40]); } catch { /* unsupported */ }
}
